import {Component, EventEmitter, OnInit, Output, ViewChild,} from '@angular/core';

import {MatStepper} from '@angular/material/stepper';
import {AcheteurService} from '../../../modules/services/acheteur/acheteur.service';
import {AddInfoGeneraleAcheteurComponent} from './inscription-acheteur/add-info-generale-acheteur/add-info-generale-acheteur.component';
import {ToastService} from '../../../modules/toast/toast.service';
import {Router} from '@angular/router';
import {TransferidAchteurService} from './transferid-achteur.service';
import {CommmCode} from '../../../utils/constante/CommonCode';

@Component({
    selector: 'app-acheteur',
    templateUrl: './acheteur.component.html',
    styleUrls: ['./acheteur.component.css'],
})
export class AcheteurComponent implements OnInit {
    @ViewChild(MatStepper) stepper: MatStepper;
    @ViewChild('step1') form: AddInfoGeneraleAcheteurComponent;
    @Output() recap = new EventEmitter<any>();


    commonCode = CommmCode;
    formINFO: any;
    formINFOInter: any;

    constructor(
        private achteurservice: AcheteurService,
        private toast: ToastService,
        private routee: Router,
        private transferidAchteurService: TransferidAchteurService
    ) {
    }

    ngOnInit(): void {
    }

    onnext(formInfo) {
        this.formINFO = formInfo;
        this.stepper.next();
    }

    nextstep(formInfoiNTER) {
        this.formINFOInter = formInfoiNTER;
        this.stepper.next();
    }

    submit(form1, form2) {
        const bj = Object.assign(form1, form2);
        this.achteurservice.saveachteur(bj).subscribe({
            next: (res) => {
                this.transferidAchteurService.setData(res.umRcvInstId);
            },
            error: () => {
                this.toast.error();
            },
            complete: () => {
                this.toast.success('saved_successfully');
                this.routee.navigateByUrl('/portail/acheteur/details');
            },
        });
    }
}
